/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */
import 'expose-loader?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';
import $, { get } from 'jquery';
// import { truncate } from 'fs';
/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const dropDownEl = $('.js-dropdown');
  const form = new Form();
  const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  const dropDown = new DropDown(dropDownEl);
  const topMenu = new TopMenu(topMenuEl);
  const productMinitature = new ProductMinitature();
  const productSelect = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();

  $('.carousel[data-touch="true"]').swipe({
    swipe(event, direction) {
      if (direction === 'left') {
        $(this).carousel('next');
      }
      if (direction === 'right') {
        $(this).carousel('prev');
      }
    },
    allowPageScroll: 'vertical',
  });

  // -----------------
  // CUSTOM JS
  // -----------------

  // Drapeaux des langues
  // $('.language-selector .expand-more:contains("Français")').css('color','red').on('click', function(){console.log('hello')});
  // $('.language-selector .expand-more:contains("Français")').replaceWith('<img src="../img/flag_fr.jpg" alt="Français">');
  
  // Mega Menu SUBMENUS -> Remove menu element if there's no submenus
  var contentSubMenus = $('.ets_mm_block_content')
  contentSubMenus.each(function(){
    if($(this).children().children().length < 1){
      // $(this).closest('.mm_blocks_li').remove();
      $(this).closest('.mm_columns_li').remove();
    }
  });

    // Mega Menu -> Remove general menu element if there's no submenus
    var contentMenusSubSpecific = $('.specific-shop .mm_columns_ul')
    contentMenusSubSpecific.each(function(){
      if($(this).children().children().children().length < 1){
        $(this).closest('.specific-shop').remove();
      }
    });

  /*TRONCATE CAT NAME IN MENU*/
  // var catNameMenu = $('.ets_mm_categories .ets_mm_url');
  // catNameMenu.each(function(){
  //   $(this).text(stringAIOCategories($(this).text()));
  // })

  /*TRONCATE CAT NAME IN CAT PAGE*/
  // var catNameCatArch = $('#category .block-category h1.h1');
  // catNameCatArch.text(stringAIOCategories(catNameCatArch.text()));

  /*TRONCATE CAT NAME IN HOMEPAGE MODULE*/
  // var catNameTitleMod = $('.hc-tab .title h2 .parent-cat');
  // if(catNameTitleMod.length > 1){
  //   catNameTitleMod.each(function(){
  //     $(this).text(stringAIOCategories($(this).text()));
  //   });
  // }else{
  //   catNameTitleMod.text(stringAIOCategories(catNameTitleMod.text()));
  // }

  /*BREADCRUMB*/
  // var breadCrumbItems = $('.breadcrumb ol li span')
  // breadCrumbItems.each(function(){
  //   $(this).text(stringAIOCategories($(this).text())).css('color','#FFF');
  // })

  /*FILTRE A FACETTES TRUNCATE*/
  // var facetSubCatName = $('.category-sub-menu li a');
  // facetSubCatName.each(function(){
  //   $(this).text(stringAIOCategories($(this).text()))
  // })

  // var facetCatName = $('.facet-label a');
  // facetCatName.each(function(){
  //   $(this).text(stringAIOCategories($(this).text()))
  // })

  // prestashop.on('updateFacets', function(){
  //   console.log(facetCatName);
  //   var facetCatName = $('.facet-label a');
  //   facetCatName.each(function(){
  //     console.log(stringAIOCategories($(this).text()))
  //     $(this).text(stringAIOCategories($(this).text()))
  //   })
  // })
  
  /*Enlève les éléments d'une string s'ils existent avant - et après le |*/
  // function stringAIOCategories(str){
  //   var initialString = str;
  //   var removedDash;
  //   var removedPipe;
  //   if(initialString.indexOf('-') !== -1){
  //     var dashIdentifier = initialString.indexOf("-");
  //     var removedDash = initialString.substring(dashIdentifier + 2);
  //   }else{
  //     removedDash = initialString;
  //   }
  //   if(removedDash.indexOf('|') !== -1){
  //     var pipeIndentifier = removedDash.indexOf(' |');
  //     removedPipe = removedDash.slice(0, pipeIndentifier);
  //   }else{
  //     removedPipe = removedDash;
  //   }
  //   str = removedPipe;
  //   return str;
  // }

  //ajout classe prévention si titre dans menu contient le terme spécifique
  var stringChecker = $('.mm_menu_content_title');
  stringChecker.each(function(){
     let stringMenu = $(this).text()
     let boolChecker = checkIfContainsString(stringMenu)
     let parentToAdd = $(this).closest(".mm_menus_li")
     if(boolChecker){
      if(!parentToAdd.hasClass("specific-shop")){
        parentToAdd.addClass('specific-shop')
      }
     }
  })
  
  //Fonction pour check si la chaîne de caractères contient le mot spécifique
  function checkIfContainsString(string){
    if(string.indexOf("Spécifique") > -1){
      return true
    }else{
      return false
    }
  }

  // Slider principal
  $('.products_slick').slick({
    arrows: false,
    dots: true
  });

  // Slider vidéos
  $('.hc-products-166 .hc-products-list').slick({
    arrows: false,
    dots: true,
    slidesToShow: 3
  });

  // Texte de présentation de la section vidéos
  $('.hc-cat[data-id-category="166"]').text('Looking for inspiration?');
  $('.hc-tab[data-id-category="166"] .title h2').after('<h3>Check out our latest videos</h3>');
  $('.hc-tab[data-id-category="166"] .title h3').after('<p>We have already made many types of Karakuri Kaizen® that can inspire you</p>');

  // Slider components
  $('.hc-products-4  .hc-products-list').slick({
    arrows: false,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Slider video
  $('.hc-product-container-videos  .hc-products-list').slick({
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  if ($(window).width() < 1024) {
    // Slider video
    var firstCarousel = $('.hc-tab:first-child() .hc-products-list')
    firstCarousel.first().slick({
      arrows: false,
      dots: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
  
    // Slider video
    $('#hc-tab-107 .hc-products-list').slick({
      arrows: false,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });





  /*S'il y a une vidéo dans la page(description), remplace les photos par la vidéo*/
  // var replaceWith = $('#product iframe')
  // var replace = $("#product .product-cover")
  // replaceIframe(replace, replaceWith)
  // function replaceIframe(element, iframe){
  //   if(iframe.length === 1){
  //     element.html(iframe)
  //   }
  // }

  var h1Height = $('#product h1.h1').outerHeight(true);
  var descHeight = $('#product .product-information .product-description').outerHeight(true);
  var heighCalc = h1Height + descHeight + 20;
  $('#product .pack #ap5-buy-container .product-prices').css('top', heighCalc);


  /*AJOUT PACK AVEC MODIFICATIONS*/
  function excludedProductLength(){
    if($('.ap5-is-excluded-product').length > 0){
      return true
    }
    return false
  }
  function checkQuantities(obj, inputs) {
    var mismatch = false
    inputs.each(function() {
      var id = $(this).attr('id')
      var value = $(this).val()
      if (obj.hasOwnProperty(id) && obj[id] !== value) {
        console.log("La valeur de l'élément " + id + " ne correspond pas à celle de l'objet.")
        mismatch = true
      }
    });
    return mismatch
  }  
  var quantitiesOriginals = $('.ap5-quantity-wanted');
  var quantitiesOriginalsObject = {};
  quantitiesOriginals.each(function(){
    var key = $(this).attr('id');
    var value = $(this).val();
    quantitiesOriginalsObject[key] = value;
  });
  $(document).on('click', '.add-to-cart', function(){
    if(excludedProductLength() || checkQuantities(quantitiesOriginalsObject, $('.ap5-quantity-wanted'))){
      $(document).on('shown.bs.modal', '#blockcart-modal', function() {
        if($('#blockcart-modal .alert-aio').length < 1){
          $('#blockcart-modal .modal-header').after(
            '<div class="alert alert-aio">' +
                'Attention : Lorsque vous retirez un élément du pack ou modifiez une quantité d\'un élément du pack, les composants individuels seront affichés dans votre panier, et non le pack complet.' +
            '</div>'
          )
        }
      })
    }else{
      $(document).on('shown.bs.modal', '#blockcart-modal', function() {
        $('#blockcart-modal .alert-aio').remove()
      })
    }
  })
  /*END PACK*/

  var associatedProducts = $('#product .product-accessories > .products')
  var associatedProductsCount = associatedProducts.children().length
  if(associatedProductsCount > 3){
    associatedProducts.first().slick({
      arrows: false,
      dots: false,
      slidesToShow: 4,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    })
  }else{
    if ($(window).width() < 768 && associatedProductsCount > 1) {
      associatedProducts.first().slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true
      })
    }
  }

  /*SCROLL ATTACHMENT FOR FILTERS*/
  if ($(window).width() > 768) {
    if($('body').hasClass('page-category')){
      if($('#search_filters_wrapper').children('#search_filters').length === 0){
        $('#search_filters_wrapper').append('<p style="margin: 0;">Aucun filtre disponible</p>')
      }else{
        if ($(window).width() > 1200) {
          var wrapper = $('#search_filters_wrapper');
          const wrapperTop = wrapper.offset().top;
          var scrollTop = $(window).scrollTop();
          var recalcWidth = $('#left-column').width();
          $(window).scroll(function() {
            if ($(window).scrollTop() >= wrapperTop) {
              wrapper.addClass('fixed-position').css({'width': recalcWidth})
            }else {
              wrapper.removeClass('fixed-position').removeAttr('style')
            }
          })
        }
      }
    }
  }
  
})


$(document).ready(function(){
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'style') {
        var searchWidgetOffset = $('#search_widget').offset();
        var searchWidgetWidth = $('#search_widget').innerWidth();
        var searchHeight = $('.ui-autocomplete-input').outerHeight();
        var newH = searchHeight + searchWidgetOffset.top; 
        $('.ui-autocomplete').css({
          'left': searchWidgetOffset.left + 'px',
          'width': searchWidgetWidth + 'px',
          'top': newH + 'px'
        });
      }
    });
  });
  var config = { attributes: true, childList: false, characterData: false };
  var checkExist = setInterval(function() {
    var target = document.querySelector('.ui-autocomplete');
    if (target) {
      observer.observe(target, config);
      clearInterval(checkExist);
    }
  }, 100);
});

$(document).ready(function() {
  $('select#pagination_nbr').on('change', function() {
    var url = $(this).find('option:selected').data('href');
    console.log(url)
      if (url) {
          window.location.href = url;
      }
  });
});

// PATCH PROBLEME DES images MODALS AVEC LES PACKS DE PM ADVANCED PACk
// $(document).ready(function(){
//   if($('body').attr('id') === 'product'){
//     const coverImage = $(document).find('.js-images-container .product-cover')
//     const coverImageSrc = $(document).find('.js-qv-product-cover').attr('src')
//     const coverImageAlt = $(document).find('.js-qv-product-cover').attr('alt')
//     const productModal = $('#product-modal')
//     const packName = $('.card-block h1 p').text()
//     const thumbs = $(document).find('.js-qv-product-images').children().clone()
//     coverImage.click(function(){
//       if($('body').hasClass('ap5-pack-page')){
//         const modalSave = productModal.find('.modal-content').clone()
//         productModal.find('.product-cover-modal').attr('src', coverImageSrc)
//         productModal.find('.product-cover-modal').attr('alt', coverImageAlt)
//         productModal.find('#product-description-short').text(packName)
//         productModal.find('.product-images').children().remove()
//         productModal.find('.product-images').append(thumbs)
//         const newPM = productModal.find('.product-images').children()
//         newPM.each(function(){
//           $(this).find('img').attr('src', replaceWithLargeDefault($(this).find('img').attr('src')))
//         })
//         productModal.on('hidden.bs.modal', function () {
//           productModal.find('.modal-content').replaceWith(modalSave);
//         });
//         const thumbsAppened = productModal.find('.product-images').children()
//         thumbsAppened.each(function(){
//           $(this).click(function(){
//             thumbsAppened.find('img').removeClass('selected');
//             $(this).find('img').addClass('selected');
//             productModal.find('.product-cover-modal').attr('src', replaceWithLargeDefault($(this).find('img').attr('src')));
//           })
//         });      
//       }
//     })
//   }
// })

// PATCH PROBLEME DES images MODALS AVEC LES PACKS DE PM ADVANCED PACk
$(document).ready(function(){
  if($('body').attr('id') === 'product'){
    const coverImage = $(document).find('.js-images-container .product-cover')
    const coverImageSrc = $(document).find('.js-qv-product-cover').attr('src')
    const coverImageAlt = $(document).find('.js-qv-product-cover').attr('alt')
    const packName = $('.card-block h1 p').text()
    const thumbs = $(document).find('.js-qv-product-images').children().clone()
    var modalClone = $('#product-modal').clone()
    modalClone.attr('id', 'product-modal-cover-def')
    modalClone.addClass('product-modal')
    modalClone.find('.product-cover-modal').attr('src', coverImageSrc)
    modalClone.find('.product-cover-modal').attr('alt', coverImageAlt)
    modalClone.find('#product-description-short').text(packName)
    modalClone.find('.product-images').children().remove()
    modalClone.find('.product-images').append(thumbs)
    var newPM = modalClone.find('.product-images').children()
    newPM.each(function(){
      $(this).find('img').attr('src', replaceWithLargeDefault($(this).find('img').attr('src')))
    })
    const thumbsAppened = modalClone.find('.product-images').children()
    thumbsAppened.each(function(){
      $(this).click(function(){
        thumbsAppened.find('img').removeClass('selected');
        $(this).find('img').addClass('selected');
        modalClone.find('.product-cover-modal').attr('src', replaceWithLargeDefault($(this).find('img').attr('src')));
      })
    });   
    coverImage.click(function(){
      if($('body').hasClass('ap5-pack-page')){
        modalClone.find('.product-cover-modal').attr('src', coverImageSrc)
        modalClone.find('.product-cover-modal').attr('alt', coverImageAlt)
        $(this).find('[data-target]').attr('data-target', '#product-modal-cover-def');
        if(!$('#product-modal-cover-def').length){
          $('body').append(modalClone)
        }
      }
    })
  }
})

function replaceWithLargeDefault(url) {
  return url.replace('small_default', 'large_default');
}







